import React from 'react';
import { Table, Card, Tag } from 'antd';
import styles from './Network.module.scss';

const NetworkInfo = ({ networkData }) => {
  // 네트워크 인터페이스 데이터 파싱
  const parseNetworkData = (data) => {
    if (!data || data === 'N/A') return [];
    
    try {
      // 문자열 데이터를 파싱하여 인터페이스 정보 추출
      const interfaces = [];
      const lines = data.trim().split('\n');
      
      let currentInterface = null;
      
      lines.forEach(line => {
        if (line.match(/^\d+: ([^:]+):/)) {
          // 새 인터페이스 시작
          const name = line.match(/^\d+: ([^:]+):/)[1];
          currentInterface = {
            name,
            status: line.includes('UP') ? 'UP' : 'DOWN',
            mac: line.match(/link\/ether ([0-9a-f:]+)/)?.[1] || 'N/A',
            flags: line.match(/<([^>]+)>/)?.[1].split(',') || [],
            addresses: [],
            key: name
          };
          interfaces.push(currentInterface);
        } else if (currentInterface && line.includes('inet ')) {
          // IPv4 주소
          const match = line.match(/inet (\d+\.\d+\.\d+\.\d+)\/(\d+)/);
          if (match) {
            currentInterface.addresses.push({
              type: 'IPv4',
              address: match[1],
              prefix: match[2],
              key: `${currentInterface.name}-ipv4-${currentInterface.addresses.length}`
            });
          }
        } else if (currentInterface && line.includes('inet6 ')) {
          // IPv6 주소
          const match = line.match(/inet6 ([0-9a-f:]+)\/(\d+)/);
          if (match) {
            currentInterface.addresses.push({
              type: 'IPv6',
              address: match[1],
              prefix: match[2],
              key: `${currentInterface.name}-ipv6-${currentInterface.addresses.length}`
            });
          }
        }
      });
      
      return interfaces;
    } catch (error) {
      console.error('Error parsing network data:', error);
      return [];
    }
  };

  const interfaces = parseNetworkData(networkData);

  return (
    <Card title="네트워크 인터페이스 정보" className={styles.networkCard}>
      <Table 
        dataSource={interfaces}
        rowKey="name"
        pagination={false}
        expandable={{
          expandedRowRender: record => (
            <div className={styles.expandedRow}>
              <p><strong>상태:</strong> <Tag color={record.status === 'UP' ? 'green' : 'red'}>{record.status}</Tag></p>
              <p><strong>플래그:</strong> {record.flags.map(flag => <Tag key={flag}>{flag}</Tag>)}</p>
              <h4>IP 주소</h4>
              <Table 
                dataSource={record.addresses}
                columns={[
                  { title: '유형', dataIndex: 'type', key: 'type' },
                  { title: '주소', dataIndex: 'address', key: 'address' },
                  { title: '프리픽스', dataIndex: 'prefix', key: 'prefix' }
                ]}
                pagination={false}
                size="small"
                rowKey="key"
              />
            </div>
          )
        }}
        columns={[
          { title: '인터페이스', dataIndex: 'name', key: 'name' },
          { title: '상태', dataIndex: 'status', key: 'status', 
            render: status => <Tag color={status === 'UP' ? 'green' : 'red'}>{status}</Tag> 
          },
          { title: 'MAC 주소', dataIndex: 'mac', key: 'mac' },
          { title: 'IP 주소', key: 'ip', 
            render: record => record.addresses.map((addr, i) => 
              <div key={i}>{addr.address}/{addr.prefix}</div>
            )
          }
        ]}
      />
    </Card>
  );
};

export default NetworkInfo;